import type { ConfigurationContextValue } from "./ConfigurationContext";
import type { DealPipeline } from "../types";
// Import the logos as module assets so Vite resolves their URL relative to the
// JS chunk (import.meta.url), not the current route. A plain "./logos/..." path
// breaks on nested routes like /oauth/consent and under a deployment sub-path.
import darkModeLogo from "./logos/logo_dotus_dark.png";
import lightModeLogo from "./logos/logo_dotus_light.png";

export const defaultDarkModeLogo = darkModeLogo;
export const defaultLightModeLogo = lightModeLogo;

export const defaultCurrency = "BRL";

export const defaultTitle = "Dotus";

export const defaultCompanySectors = [
  { value: "servicos", label: "Serviços" },
  { value: "comercio", label: "Comércio" },
  { value: "industria", label: "Indústria" },
  { value: "tecnologia", label: "Tecnologia" },
  { value: "saude", label: "Saúde" },
  { value: "construcao-civil", label: "Construção Civil" },
  { value: "alimentacao", label: "Alimentação" },
  { value: "outro", label: "Outro" },
];

export const defaultDealStages = [
  { value: "entrada-de-prospect", label: "Entrada de Prospect" },
  { value: "tentando-contato", label: "Tentando Contato" },
  { value: "contato-realizado", label: "Contato Realizado" },
  { value: "qualificacao", label: "Qualificação" },
  { value: "qualificado", label: "Qualificado" },
  { value: "reuniao-agendada", label: "Reunião Agendada" },
  { value: "reuniao-realizada", label: "Reunião Realizada" },
  { value: "proposta-criada", label: "Proposta Criada" },
  { value: "negociacao", label: "Negociação" },
  { value: "venda", label: "Venda" },
];

export const defaultDealPipelines: DealPipeline[] = [
  {
    id: "funil-de-vendas",
    nome: "Funil de Vendas",
    descricao: "Funil padrão de vendas e negociações",
    etapas: defaultDealStages,
  },
];

export const defaultDealPipelineStatuses = ["venda", "won"];

export const defaultDealCategories = [
  { value: "contabilidade-mensal", label: "Contabilidade Mensal" },
  { value: "bpo-financeiro", label: "BPO Financeiro" },
  { value: "abertura-empresa", label: "Abertura de Empresa" },
  { value: "recuperacao-tributaria", label: "Recuperação Tributária" },
  { value: "outro", label: "Outro" },
];

export const defaultNoteStatuses = [
  { value: "frio", label: "Frio", color: "#60a5fa" },
  { value: "morno", label: "Morno", color: "#facc15" },
  { value: "quente", label: "Quente", color: "#f87171" },
  { value: "em-contrato", label: "Em Contrato", color: "#4ade80" },
];

export const defaultLeadTemperatures = [
  { value: "frio", label: "Frio" },
  { value: "morno", label: "Morno" },
  { value: "quente", label: "Quente" },
];

export const defaultLeadSources = [
  { value: "indicacao", label: "Indicação" },
  { value: "google", label: "Google" },
  { value: "instagram", label: "Instagram" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "outbound", label: "Outbound" },
  { value: "outro", label: "Outro" },
];

export const defaultTaskTypes = [
  { value: "chamada", label: "Chamada" },
  { value: "reuniao", label: "Reunião" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "email", label: "E-mail" },
  { value: "follow-up", label: "Follow-up" },
  { value: "visita", label: "Visita" },
  { value: "tarefa", label: "Tarefa" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  dealPipelines: defaultDealPipelines,
  currentPipelineId: "funil-de-vendas",
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
  leadSources: defaultLeadSources,
  leadTemperatures: defaultLeadTemperatures,
};
